import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PageSupporting = ({ user, setUser }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSignOut = async () => {
        setLoading(true);
        try {
            await fetch('/api/auth/signout', {
                method: 'POST',
                credentials: 'include'
            });
            setUser(null);
            window.location.href = '/';
        } catch (err) {
            console.error('Error signing out:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: "100vh",
            backgroundColor: "white",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center"
        }}>
            <h1 style={{
                fontFamily: "'American Typewriter', 'Courier New', Courier, monospace",
                fontSize: "3.0rem",
                marginBottom: "10px",
                marginLeft: "10px"
            }}>OneWriter<sup style={{ fontSize: "0.4em", verticalAlign: "0.5em" }}>&#8482;</sup></h1>

            <div style={{ lineHeight: "1.3", marginBottom: "16px", fontWeight: "600", fontFamily: "Arial, Helvetica, sans-serif" }}>
                <p style={{ margin: "2px 0", fontStyle: "italic" }}>It's a Word Processor</p>
                <p style={{ margin: "2px 0", fontStyle: "italic" }}>and a Spreadsheet</p>
                <p style={{ margin: "2px 0", fontStyle: "italic", marginLeft: "-5px" }}>
                    <span style={{ fontSize: "1.5em", verticalAlign: "-0.2em" }}>&ldquo;</span>
                    <span style={{ display: "inline-block", width: "3px" }} />
                    IN ONE APP
                    <span style={{ display: "inline-block", width: "1px" }} />
                    <span style={{ fontSize: "1.5em", verticalAlign: "-0.2em" }}>&rdquo;</span>
                </p>
            </div>

            {user && (
                <div style={{
                    width: "100%",
                    maxWidth: "320px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px"
                }}>
                    <div style={{ padding: "14px", textAlign: "left" }}>
                        <p style={{ margin: "0", fontSize: "12px", color: "#444", fontWeight: "700" }}>Your account:</p>
                    </div>

                    <div style={{ backgroundColor: "#f5f5f5", borderRadius: "8px", padding: "14px", textAlign: "left" }}>
                        <p style={{ margin: "0 0 6px 0", fontSize: "12px", color: "#666" }}>Email</p>
                        <p style={{ margin: 0, fontWeight: "500" }}>{user.email}</p>
                    </div>

                    <div style={{ backgroundColor: "#f5f5f5", borderRadius: "8px", padding: "14px", textAlign: "left" }}>
                        <p style={{ margin: "0 0 6px 0", fontSize: "12px", color: "#666" }}>User ID</p>
                        <p style={{ margin: 0, fontWeight: "500", fontSize: "13px", wordBreak: "break-all" }}>{user.id}</p>
                    </div>

                    <button
                        onClick={() => navigate('/app')}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#333";
                            e.target.style.borderColor = "#333";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#000";
                            e.target.style.borderColor = "#000";
                        }}
                        onMouseDown={(e) => {
                            e.target.style.backgroundColor = "#555";
                            e.target.style.transform = "scale(0.98)";
                        }}
                        onMouseUp={(e) => {
                            e.target.style.backgroundColor = "#333";
                            e.target.style.transform = "scale(1)";
                        }}
                        style={{
                            padding: "10px 20px",
                            marginTop: "10px",
                            width: "100%",
                            backgroundColor: "#000",
                            color: "#fff",
                            border: "1px solid #000",
                            borderRadius: "8px",
                            fontSize: "14px",
                            cursor: "pointer",
                            transition: "background-color 0.15s ease, transform 0.1s ease"
                        }}
                    >
                        Return to your OneWriter Project
                    </button>

                    <button
                        onClick={handleSignOut}
                        disabled={loading}
                        onMouseEnter={(e) => {
                            if (!loading) {
                                e.target.style.backgroundColor = "#8c4a4a";
                                e.target.style.borderColor = "#8c4a4a";
                                e.target.style.color = "#fff";
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!loading) {
                                e.target.style.backgroundColor = "white";
                                e.target.style.borderColor = "gray";
                                e.target.style.color = "#6b2f2f";
                            }
                        }}
                        onMouseDown={(e) => {
                            if (!loading) {
                                e.target.style.backgroundColor = "#7a3d3d";
                                e.target.style.borderColor = "#7a3d3d";
                                e.target.style.color = "#fff";
                                e.target.style.transform = "scale(0.98)";
                            }
                        }}
                        onMouseUp={(e) => {
                            if (!loading) {
                                e.target.style.backgroundColor = "#8c4a4a";
                                e.target.style.borderColor = "#8c4a4a";
                                e.target.style.color = "#fff";
                                e.target.style.transform = "scale(1)";
                            }
                        }}
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "white",
                            color: "#6b2f2f",
                            border: "1px solid gray",
                            borderRadius: "8px",
                            fontSize: "14px",
                            cursor: loading ? "not-allowed" : "pointer",
                            transition: "background-color 0.15s ease, transform 0.1s ease"
                        }}
                    >
                        {loading ? "Logging out..." : "Log Out"}
                    </button>
                </div>
            )}

            <p style={{ marginTop: "40px", fontSize: "12px", color: "#444" }}>
                Created by Jamie Kayam | App About It © {new Date().getFullYear()}
            </p>
        </div>
    );
};

export default PageSupporting;